module.exports = __webpack_public_path__ + "static/img/over-date-card.8f054e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/over-date-card.png
// module id = LxP6
// module chunks = 216